<div *ngIf="!activated()" class="w-full max-w-md rounded-2xl border border-white/20 bg-white/95 backdrop-blur-sm p-8 shadow-xl">
  <div class="text-center mb-8">
    <div class="mx-auto max-w-sm">
      <h1 class="text-2xl font-title font-semibold text-gray-900 mb-2">Activación de tu cuenta</h1>
      <p class="text-theme-sm text-gray-600 ">
        Define una contraseña y finaliza la activación.
      </p>
    </div>
    <div class="relative text-center my-6 h-px bg-gray-200"></div>
  </div>

  <form class="mt-6 space-y-4" (ngSubmit)="onSubmit()" [formGroup]="form">
    <div>
      <label class="block text-sm font-medium text-gray-800" for="password">Nueva contraseña</label>
      <input type="password" id="password" formControlName="password"
        class="mt-1 w-full rounded-xl border border-gray-300 bg-white/95 px-3 py-2 text-gray-700 outline-none focus:border-brand-400 focus:ring-2 focus:ring-brand-200 placeholder:text-gray-300"
        placeholder="Mínimo 8 caracteres" [disabled]="loading() || tokenMissing()" autocomplete="new-password" />
      <p *ngIf="passwordErrorText" class="mt-1 text-xs text-red-600">
        {{ passwordErrorText }}
      </p>
    </div>

    <div class="mb-6">
      <label class="block text-sm font-medium text-gray-800" for="confirmPassword">Repite la contraseña</label>
      <input type="password" id="confirmPassword" formControlName="confirmPassword"
        class="mt-1 w-full rounded-xl border border-gray-300 bg-white/95 px-3 py-2 text-gray-700 outline-none focus:border-brand-400 focus:ring-2 focus:ring-brand-200 placeholder:text-gray-300"
        placeholder="Vuelvela a escribir" [disabled]="loading() || tokenMissing()" autocomplete="new-password" />
      <p *ngIf="confirmPassword?.touched && confirmPassword?.hasError('required')" class="mt-1 text-xs text-red-600">
        La confirmación es obligatoria.
      </p>
      <p *ngIf="form.touched && form.hasError('passwordsMismatch')" class="mt-1 text-xs text-red-600">
        Las contraseñas no coinciden.
      </p>
    </div>

    <lib-button className="w-full" color="brand" (btnClick)="onSubmit()" [disabled]="!canSubmit() || form.invalid">
      <span *ngIf="!loading()">Finalizar</span>
    </lib-button>
  </form>
</div>

<br>

<div *ngIf="activated()" class="w-full max-w-md rounded-2xl border border-white/20 bg-white/95 backdrop-blur-sm p-8 shadow-xl">
  <div class="text-center mb-8">
    <div class="mx-auto max-w-sm">
      <h2 class="text-2xl font-title font-semibold text-gray-900 mb-2">Cuenta activada</h2>
      <p class="text-theme-sm text-gray-600">Puedes acceder a tu Agronic Net.</p>
    </div>
    <div class="relative text-center my-6 h-px bg-gray-200"></div>
    <p class="text-theme-md text-gray-700 leading-relaxed mx-auto max-w-sm">
      {{ successMessage() }}
    </p>
  </div>
  <lib-button className="w-full" (btnClick)="goToSignIn()">
    Continuar
  </lib-button>
</div>